import React, {Component} from 'react'
import Header from "../components/header"
import Footer from "../components/footer"
import '../../static/css/style.scss'
import CardItem from "../components/cardItem"
class Canada extends Component {
	state={
		youshi:[
			{
				name:'一流的教育质量',
				content:'加拿大拥有全球认可的北美教育体系，教育质量一流。教育经费占政府财政支出的大部分。大学和学院，各个公立各个大学得到的资源相对比较平均。各级学校管理严格，学科设置科学全面，师资力量雄厚。 加拿大学历和学位得到全世界的认可。',
			},
			{
				name:'留学费用相对较低',
				content:'相比其他欧美国家，加拿大学费较低。 以本科为例，加拿大公立大学的学费在2万5加币左右， 而美国私立大学(美国大学主要为私立)大多在3万美元左右。',
			},
			{
				name:'录取率高',
				content:'加拿大的各级学校(中小学、本科和研究生)，对符合条件的国际学生录取率高。选择自己适合的几所学校， 按照学校的录取要求做准备，准备齐全申请材料，保证申请材料的质量，按时申请，拿到offer的概率是非常高的。',
			},
			{
				name:'就业机会多，起薪高',
				content:'加拿大大专院校、本科院校及以上学历的留学生， 毕业后可直接申请获得1-3年的工签，可以在加拿大各个省市找工作。 加拿大各个省市都有最低工资要求，保证了就业人员的起薪。',
			},
			{
				name:'留学生签证政策优化',
				content:'加拿大使馆不断优化简化留学生申请签证的政策。签证时间加快。',
			},
			{
				name:'校园和社会治安优良',
				content:'在欧美等西方国家中，加拿大的校园和社会治安可谓名列前茅。 与美国不同的是，加拿大严控枪支和毒品，因此加拿大社会犯罪率和暴力事件控制在很低的水平。',
			},
			{
				name:'移民政策好社会福利高',
				content:'据一项新的全球性调查显示，加拿大是全球最接受移民的国家，排在第2及第3位的分别为冰岛和新西兰，美国排名第6。加拿大被称为"移民的国家"，因为除原居民外，所有人都是外来移民。政府鼓励多元文化的并存和发展，因为加拿大是许多不同民族的人组成。',
			},
		],
		zhuanye:[
			{
				title:'金融专业',
				content:'金融专业在加拿大是一个备受青睐的热门专业，主要课程有政治经济学、西方经济学（宏观经济学微观经济学）、财政学、国际经济学、货币银行学、国际金融管理、证券投资学、保险学、商业银行业务管理、中央银行业务、投资银行理论与实务等。<br><br> 推荐院校：多伦多大学、麦克马斯特大学、北英属哥伦比亚大学、西安大略大学、西门菲莎大学、圣玛丽大学。',
				img:require('../../static/images/canada03.jpg')
			},
			{
				title:'会计专业',
				content:'会计专业是众多学子的选择，会计专业在加拿大属于比较紧缺的专业，主要课程有管理学、微观经济学、宏观经济学、管理信息系统、统计学、会计学、财务管理、市场营销、经济法、财务会计、成本会计、管理会计、审计学。主要学中级财务会计、高级财务会计、财务管理等，基础课有：管理学、宏观经济学、微观经济学等课程。<br><br>推荐院校：多伦多大学、滑铁卢大学、麦克马斯特大学、萨省大学、布鲁克大学。',
				img:require('../../static/images/canada04.jpg')
			},
			{
				title:'计算机科学专业/IT专业',
				content:'计算机现在已成为加拿大经济和民众生活中不可或缺的一部分，而计算机和网络系统的发展从很多方面改变了人们的生活方式。加拿大的计算机以及相关行业目前仍在扩张，对计算机专业毕业生的需求也依然维持在一个可观的增速上。\n' +
					'在计算机科学专业中，最受就业市场欢迎的毕业生是在计算机科学、技术支持、信息技术和系统方面有专长的毕业生。 <br><br> 推荐院校：多伦多大学、滑铁卢大学、皇后大学、戴尔豪斯大学、新布伦瑞克大学、英属哥伦比亚大学、阿卡迪亚大学。',
				img:require('../../static/images/canada05.jpg')
			},
			{
				title:'管理类专业',
				content:'加拿大管理类专业数酒店旅游管理最吃香，因为加拿大酒店业非常发达，需要人才较多，当地人口少，给国际学生提供了很好的机会。加拿大一些学校开设了酒店管理专业，只需三年即可完成本科课程，其中还包括一年的带薪实习课程。\n' +
					'主要课程有：旅游英语、旅游日语、旅游心理学、中外礼仪、旅游法规、饭店会计、餐饮运行与管理、前厅运行与管理、客房服务与管理、形体、导游业务、旅行社管理、现代宾馆管理。<br><br> 推荐院校：维多利亚大学、圭尔夫大学、康考迪亚大学。',
				img:require('../../static/images/canada06.jpg')
			},
			{
				title:'土木工程专业',
				content:'在加拿大土木工程专业要求很高，很多学校要求雅思7.0以上，部分要求有工作经验，主要课程有：工程力学、流体力学、岩土力学、地基和基础、工程地质学、工程水文学、工程制图、计算机应用、建筑材料、混凝土结构、' +
					'钢结构、工程结构、给水排水工程、施工技术与管理、工程制图、认识实习、测量实习、工程地质实习、专业实习或生产实习、结构课程设计等。<br><br> 推荐院校：多伦多大学、滑铁卢大学、女王大学、温莎大学、戴尔豪斯大学。',
				img:require('../../static/images/canada07.jpg')
			},
		],
		liucheng:[
			{
				name:'要初步了解加拿大学校',
				content:'在准备加拿大本科留学申请时，同学们要首先了解自己感兴趣的学校，先做基本了解。在大概了解加拿大大学总体状况后，就可以基本定位自己想做深入了解的学校、' +
					'对于想要留在加拿大的同学来说，专业排名与就业率比学校排名重要。'
			},
			{
				name:'申请过程的开始',
				content:'根据学校申请要求按照材料清单准备申请材料，并填写学校的网申，争取在截止之前尽早提交申请。如果在提交网申时还没考到理想的语言成绩，可以根据学校的规定在提交网申之后补语言成绩。'
			},
			{
				name:'登入学生系统，查询状态',
				content:'申请表递交后，学校会你给填的邮箱里发一封邮件，里面包含你要用的用户名和密码。通过这个用户名和密码就能登入申请学校的系统，' +
					'里面会列出申请状态、材料清单(已交和未交)、奖学金申请情况等。'
			},
			{
				name:'材料的递送',
				content:'根据清单，把需要递交的材料全递交过去。在递交这些之前，如果其他材料齐备，是有机会拿到有条件录取通知书的，可以用这个通知书来办签证。' +
					'一定要在截止日期之前将材料递到学校，请将寄送所需时间考虑在内。'
			},
			{
				name:'录取结果的等待',
				content:'这是个漫长而煎熬的过程，尤其对于没有GAP的应届申请生来说，要一边忍受高三的各种考试和众多作业，一边等待国外大学的offer，' +
					'而且很多加拿大学校要高考成绩，所以同学们这段时间仍然要好好学习，以确保最后能够顺利拿到offer。'
			},
			{
				name:'就读学校的确定',
				content:'大部分同学都是同时申请了许多所不同的学校，也会陆续收到不同的offer。在所有学校的结果都出来(或者要等的已经等到)后，接下来就是选择最终入读的学校。' +
					'确定之后按照学校的要求和规定交纳定金。'
			},
			{
				name:'办理签证',
				content:'去签证申请中心办理留学签证的流程： <br>①准备好加拿大留学签证所需材料。<br>②到就近的加拿大签证中心递交申请，不需要面试。<br>③交费，等待签证结果。<br>目前留学签证的审理周期一般为2-3个月，在签证中心柜台提交申请，请留意审理时间与周期。'
			},
			{
				name:'准备入学',
				content:'留学生所需要的日常用品，在加拿大基本都能买到，加拿大各类物品都很丰富。就加拿大的消费水平而言，这些日常生活用品不会太贵，比如：闹钟，计算器，手电，杯子，小收音机等商品在“DOLLARAMA”（一元店）会很便宜，基本都是一加元一个。' +
					'学生可以多带些有用的最新版专业书籍及其他重要的物品更好，不是急需用到的生活日用品可到加拿大之后购买。另外，加拿大法律规定房屋出租时需提供冰箱和炉灶，房东也会提供洗衣机，公寓有公共洗衣房，清洗费用也不贵。'
			},
		]
	}
	render() {
		return (
			<div className={'page'}>
				<Header/>
				<div className={'main'}>
					<img className={'banimg'} src={require('../../static/images/canada01.jpg')} alt=""/>
					<div className={'content'}>
						<div className={'title'}>
							<span>加拿大简介</span>
							<span className={'line'}/>
						</div>
						<div className={'contentModule'}>
							<div className={'text textJust'}>
								加拿大（英语∶canada），位于北美洲最北端，英联邦国家之一，素有"枫叶之国"的美礼太华。加拿大西抵太平洋，东迄大西洋，北至北冰洋，东北部和丹麦领地格陵兰岛相望，东部利尔和密克隆群岛相望，南方与美国本土接壤，西北方与美国阿拉斯加州为邻。领土面积为998万三居世界第二，国土大部分位于北极圈之内，人口主要集中在南部五大湖沿岸。著名城市有多伦多、温哥华等。
									<br/><br/>
								加拿大在教育、政府的透明度、社会自由度、生活品质及经济自由的国际排名都名列前茅。</div>
							<img className={'img'} src={require('../../static/images/canada02.jpg')} alt=""/>
						</div>
						<div className={'title'}>
							<span>加拿大留学优势</span>
							<span className={'line'}/>
						</div>
						<div className={'textModule'}>
							{
								this.state.youshi.map((item,index)=>(
									<div className={'textModuleItem'} key={index}>
										<div className={'textModuleItemFlexWrap'}>
											<div className={'textModuleItemTitle'}>{item.name}</div>
											<div className={'textModuleItemText textJust'} dangerouslySetInnerHTML={{__html:item.content}}/>
										</div>
									</div>
								))
							}
						</div>
						<div className={'title'}>
							<span>加拿大专业</span>
							<span className={'line'}/>
						</div>
						<div className={'zhuanye'}>
							{
								this.state.zhuanye.map((item,index)=>(
									<CardItem item={item} key={index}/>
								))
							}
						</div>
						<div className={'title'}>
							<span>加拿大本科申请流程</span>
							<span className={'line'}/>
						</div>
						<div className={'liuCheng'}>
							{
								this.state.liucheng.map((item,index)=>(
									<div className={'liuChengItem'} key={index}>
										<div className={'liuChengItemTitle'}>{item.name}</div>
										<div className={'liuChengItemContent textJust'} dangerouslySetInnerHTML={{__html:item.content}}/>
									</div>
								))
							}
						</div>
					</div>
				</div>
				<Footer/>
			</div>
		)
	}
}

export default Canada